enum EVpsCountry {
  RU = 'RU',
  EU = 'EU',
}

export default EVpsCountry
